export const environment = {
  //API: 'https://apim.renova.app.br/rinspection-ba/api/',
  production: true,
  enableNfseMocks: false,
  CONFIG_FILE: 'assets/config/env_prod.json',
  TINY_MCE: 'l9ccpfz4hxakwexnlvpaichhu4uw1uw8hpqvskysofumq2xn'
};